<template>
  <div class="chapter chapter--quiz">
    <section class="mt-5">
      <div class="container-fluid pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12 text-center">

            <img src="@/assets/images/shiseido_logo_black.svg" class="img-fluid">
            <h1 class="color-highlight font-size-56 font-bold mt-12" v-html="$t('PAGE06_TEXT01')">Quiz</h1>
            <div class="question__wrapper mt-8  mt-lg-14">
              <div class="question question__01 container active">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT08')">1. What are the 4 main eye area concerns of the Vital Perfection customer?</div>
                <div class="answers multiple-select answers__type-01 mt-8  mt-lg-14">
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT09')">Sagging</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT10')">Dryness</div>
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT11')">Loss of resilience</div>
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT12')">Eye bags</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT13')">Puffiness</div>
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT14')">Dark circles</div>
                </div>
                <div class="d-flex align-items-center justify-content-center mb-10">
                  <div class="next__question font-bold font-size-24 color-highlight" v-html="$t('PAGE06_SUBMIT')">Submit</div>
                </div>

              </div>
              <div class="question question__02 container">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT15')">2. I am most concerned about sagging, eye bags and tired
                  looking eyes, which eye care is best for me?  </div>
                <div class="answers single-select answers__type-02 mt-8  mt-lg-14">
                  <div class="answer" data-value="false">
                      <div class="product__line font-bold font-size-24" v-html="$t('PAGE06_TEXT16')">Benefiance</div>
                      <div class="product__name font-size-24" v-html="$t('PAGE06_TEXT17')">NutriPerfect Eye Serum</div>
                  </div>
                  <div class="answer" data-value="false">
                    <div class="product__line font-bold font-size-24" v-html="$t('PAGE06_TEXT18')">Essential Energy</div>
                    <div class="product__name font-size-24" v-html="$t('PAGE06_TEXT19')">Eye Definer</div>
                  </div>
                  <div class="answer selected" data-value="true">
                    <div class="product__line font-bold font-size-24" v-html="$t('PAGE06_TEXT20')">Vital Perfection </div>
                    <div class="product__name font-size-24" v-html="$t('PAGE06_TEXT21')">Uplifting and Firming Eye Cream</div>
                  </div>
                  <div class="answer" data-value="false">
                    <div class="product__line font-bold font-size-24" v-html="$t('PAGE06_TEXT22')">Vital Perfection </div>
                    <div class="product__name font-size-24" v-html="$t('PAGE06_TEXT23')">Uplifting and Firming Express Eye Mask</div>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-center mb-10">
                  <div class="next__question font-bold font-size-24 color-highlight" v-html="$t('PAGE06_SUBMIT')">Submit</div>
                </div>

              </div>
              <div class="question question__03 container">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT24')">3. What will I see when I use this eye cream?</div>
                <div class="answers single-select answers__type-02 mt-8  mt-lg-14">
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT25')">A Lifted, Firmer, Tighter and Brighter eye area</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT26')">A Firmer, Smoother and Plumper eye area</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT27')">A brighter and more open eye area</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT28')">A less puffy eye area</div>
                </div>
                <div class="d-flex align-items-center justify-content-center mb-10">
                  <div class="next__question font-bold font-size-24 color-highlight" v-html="$t('PAGE06_SUBMIT')">Submit</div>
                </div>

              </div>
              <div class="question question__04 container">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT29')">4. Which 3 of the following 4 statements are true when using Vital Perfection Uplifting and Firming Eye Cream?</div>
                <div class="d-flex align-items-center justify-content-center mt-4">
                  <ul class="text-left">
                    <li class="font-size-24" v-html="$t('PAGE06_TEXT29-01')">Normalizes epidermal turnover</li>
                    <li class="font-size-24" v-html="$t('PAGE06_TEXT29-02')">Promotes the production of hyaluronic acid</li>
                    <li class="font-size-24" v-html="$t('PAGE06_TEXT29-03')">Promotes the regeneration of the skin</li>
                    <li class="font-size-24" v-html="$t('PAGE06_TEXT29-04')">Increases the density of the dermis</li>
                    <li class="font-size-24" v-html="$t('PAGE06_TEXT29-05')">Promotes the production of collagen</li>
                  </ul>
                </div>
                <div class="answers multiple-select answers__type-02 mt-8  mt-lg-14">
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT30')">Retinol</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT31')">Coix seed</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT32')">Yuzu</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT33')">Ashitaba</div>
                </div>
                <div class="d-flex align-items-center justify-content-center mb-10">
                  <div class="next__question font-bold font-size-24 color-highlight" v-html="$t('PAGE06_SUBMIT')">Submit</div>
                </div>

              </div>
              <div class="question question__05 container">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT34')">5. Which 3 technologies form the basis of all Vital Perfection skincare</div>
                <div class="answers multiple-select answers__type-02 mt-8  mt-lg-14">
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT35')">Repair, Regenerate, Reactivate</div>
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT36')">Repair, Resist, Boost</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT37')">Defend, Regenerate, Reactivate</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT38')">Resist, Re-energize, Build</div>
                </div>
                <div class="d-flex align-items-center justify-content-center mb-10">
                  <div class="next__question font-bold font-size-24 color-highlight" v-html="$t('PAGE06_SUBMIT')">Submit</div>
                </div>

              </div>
              <div class="question question__06 container">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT39')">6. Select the 4 main skin function that decline around the eye area as we age</div>
                <div class="answers multiple-select answers__type-01 mt-8  mt-lg-14">
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT40')">FAT CELLS ENLARGE</div>
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT41')">WATER METABOLISM DECLINES</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT42')">FAT CELLS DECREASE</div>
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT43')">MUSCLE FIBERS DECLINE</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT44')">TOXINS INCREASE</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT45')">CELL METABOLISM IS ACCELERATED</div>
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT46')">DERMAL FIBERS DECLINE</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT47')">MUSCLE FIBERS BECOME STRONGER</div>
                </div>
                <div class="d-flex align-items-center justify-content-center mb-10">
                  <div class="next__question font-bold font-size-24 color-highlight" v-html="$t('PAGE06_SUBMIT')">Submit</div>
                </div>

              </div>
              <div class="question question__07 container">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT48')">7. Vital Perfection Uplifting and Firming Express Eye Mask should only be used by customers 45+ concerned about lifting and firming their eye area.</div>
                <div class="answers single-select answers__type-02 mt-8  mt-lg-14">
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT49')">true</div>
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT50')">false</div>

                </div>
                <div class="d-flex align-items-center justify-content-center mb-10">
                  <div class="next__question font-bold font-size-24 color-highlight" v-html="$t('PAGE06_SUBMIT')">Submit</div>
                </div>

              </div>
              <div class="question question__08 container">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT51')">8. Your customer has a special occasion coming up which product will give her instantly brighter eyes?</div>
                <div class="answers single-select answers__type-03 mt-8  mt-lg-14">
                  <div class="answer font-medium font-size-32" data-value="false"> <img src="@/assets/images/06/quiz-01.jpg" class="img-fluid"></div>
                  <div class="answer font-medium font-size-32 selected" data-value="true"> <img src="@/assets/images/06/quiz-02.jpg" class="img-fluid"></div>
                  <div class="answer font-medium font-size-32" data-value="false"> <img src="@/assets/images/06/quiz-03.jpg" class="img-fluid"></div>

                </div>
                <div class="d-flex align-items-center justify-content-center mb-10">
                  <div class="next__question font-bold font-size-24 color-highlight" v-html="$t('PAGE06_SUBMIT')">Submit</div>
                </div>

              </div>
              <div class="question question__09 container">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT52')">9. Which 2 targeted ingredients are unique to the Vital Perfection Eye Care Experts?</div>
                <div class="answers multiple-select answers__type-02 mt-8  mt-lg-14">
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT53')">Retinol</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT54')">Reneura Technology</div>
                  <div class="answer font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT55')">Matsu Pro-Sculpt Complex</div>
                  <div class="answer font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT56')">Kurenai Tru-Lift Complex</div>
                </div>
                <div class="d-flex align-items-center justify-content-center mb-10">
                  <div class="next__question font-bold font-size-24 color-highlight" v-html="$t('PAGE06_SUBMIT')">Submit</div>
                </div>

              </div>
              <div class="question question__10 container gap__text--wrapper">
                <div class="question__text font-size-32 font-bold color-highlight" v-html="$t('PAGE06_TEXT57')">10. Fill in the gaps</div>
                <div class="gap__text mt-8  mt-lg-14 font-size-32" v-html="$t('PAGE06_TEXT58')">
                  The <span></span> new eye experts from VITAL PERFECTION provide <span></span> age-related fatigue defying* action when used <span></span> giving a <span></span> more vibrant look in just <span></span> weeks.
                </div>
                <div class="overlay__01 overlay" data-index="0">
                  <div class="answer__gap font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT59')">2</div>
                  <div class="answer__gap font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT60')">4</div>
                  <div class="answer__gap font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT61')">6</div>
                </div>

                <div class="overlay__02 overlay" data-index="1">
                  <div class="answer__gap font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT62')">stronger</div>
                  <div class="answer__gap font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT63')">less</div>
                  <div class="answer__gap font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT64')">faster</div>
                </div>

                <div class="overlay__03 overlay" data-index="2">
                  <div class="answer__gap font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT65')">together</div>
                  <div class="answer__gap font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT66')">alone</div>
                </div>
                <div class="overlay__04 overlay" data-index="3">

                  <div class="answer__gap font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT68')">50%</div>
                  <div class="answer__gap font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT69')">75%</div>
                  <div class="answer__gap font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT67')">100%</div>
                </div>

                <div class="overlay__05 overlay" data-index="4">
                  <div class="answer__gap font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT71')">8</div>

                  <div class="answer__gap font-medium font-size-32 selected" data-value="true" v-html="$t('PAGE06_TEXT70')">4</div>

                  <div class="answer__gap font-medium font-size-32" data-value="false" v-html="$t('PAGE06_TEXT72')">12</div>
                </div>

                <div class="d-flex align-items-center justify-content-center mb-10 flex-column">
                  <div class="start__quiz font-bold font-size-24 color-highlight mb-4" v-on:click="register()" v-if="user.quiz.successful == 1 && user.gift_active == 1" v-html="$t('PAGE06_TEXT07')">Click here to register for your gift.</div>
                  <div class="close__module font-bold font-size-24 color-highlight " v-on:click="closeModule()" v-html="$t('GLOBAL_CLOSE')">close module</div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>



  </div>
</template>

<script>
import lrsService from "@/services/lrsService";
import Slick from 'vue-slick';
import Footer from "@/components/partials/Footer";
import jQuery from "jquery"
export default {
  name: "pages-050",
  components: {
    Slick,
    Footer,
  },
  props: {
    kapitel: ""
  },
  data: function () {
    return {
      attemptsLeft: 3,
      quizSuccess: false,
      lang: "",
      country: "",
      user: Object,
      scored: 0
    }
  },
  mounted() {
    let _this = this;
    let isFirst = true;
    console.log(this.user)
    jQuery('.next__question').on('click', function () {
      if(isFirst){
        isFirst = false;
        jQuery('.gap__text span').each(function (index) {
          console.log(this, index);
          let realIndex = index +1;
          let overlay = jQuery('.overlay__0'+realIndex);
          let word = jQuery(this).text();
          let correctAnswer = jQuery(overlay).find("[data-value='true']").text();
          jQuery(this).text(correctAnswer);
          jQuery(this).addClass('selected');
        })
      }
      jQuery('html, body').animate({
        scrollTop: 0
      }, 400);
       let current = jQuery('.question.active');
       let next = jQuery('.question.active').next();
      jQuery(current).removeClass('active');
      jQuery(next).addClass('active');

    })

  },
  created() {
    this.$store.watch(
            (state, getters) => getters.lang,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              this.lang = newValue
            },
    );
    this.$store.watch(
            (state, getters) => getters.country,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              this.country = newValue
            },
    );
    this.$store.watch(
            (state, getters) => getters.user,
            (newValue, oldValue) => {
              console.log(`Updating user from ${oldValue} to ${newValue}`);
              this.user = newValue
            },
    );
  },
  beforeMount() {
    let _this = this;
    this.lang = this.$store.getters.lang;
    this.country = this.$store.getters.country;
    this.user = this.$store.getters.user;
    if (typeof _this.user === 'string' || _this.user instanceof String){
      _this.user = JSON.parse(_this.user)
    }
  },
  methods: {
    closeModule(){
      window.open('/'+ this.country + '_' + this.lang + '/brand-choice/' ,"_self")
      // window.open('/uk_en/brand-choice/' ,"_self")
    },
    register(){
      let url = this.user.gift_url;
      window.open(url )
    },
  }
}
</script>

<style scoped>

</style>